import React, { memo } from "react";
import {
  Card,
  CardActions,
  CardContent,
  CardMedia,
  CardProps,
  Divider,
  Grid,
  Tooltip,
  Typography,
} from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import VisibilityIcon from "@material-ui/icons/Visibility";
import useEventCard from "./index.hooks";
import { Event } from "models";
import { AppButton, AppLinearProgress } from "components";
import moment from "moment";

type EventCardProps = {
  event: Event;
} & CardProps;

const EventCard = ({ event, ...props }: EventCardProps) => {
  const {
    styles,
    classes,
    atomicStyles,
    remainingTime,
    openEditDialog,
    t,
  } = useEventCard(event);

  return (
    <Card {...props}>
      <CardMedia
        component="img"
        alt="Event banner"
        height="140"
        src={event.imageUri}
        className={styles.img}
      />
      <CardContent classes={classes.cardContent}>
        <Tooltip title={event.title} enterTouchDelay={1}>
          <Typography className={styles.title} noWrap>
            {event.title}
          </Typography>
        </Tooltip>
        <Divider className={styles.titleDivider} />
        <Tooltip title={remainingTime} enterTouchDelay={1}>
          <div>
            <AppLinearProgress
              percentage={Event.getCompletionPercentage(
                event.validFrom,
                event.expire,
                moment(),
              )}
            />
            <Grid container justify="space-between">
              <Grid item>
                <Typography className={styles.date}>
                  {event.formattedFrom}
                </Typography>
              </Grid>
              <Grid item>
                <Typography className={styles.date}>
                  {event.formattedTo}
                </Typography>
              </Grid>
            </Grid>
          </div>
        </Tooltip>
        <CardActions disableSpacing classes={classes.actions}>
          <AppButton
            fullWidth
            startIcon={<VisibilityIcon />}
            onClick={() => openEditDialog(false)}
          >
            {t("Anteprima")}
          </AppButton>
          <AppButton
            fullWidth
            startIcon={<EditIcon />}
            onClick={() => openEditDialog(true)}
          >
            {t("Modifica")}
          </AppButton>
        </CardActions>
      </CardContent>
    </Card>
  );
};

export default memo(EventCard);
